import { TFunction } from 'next-i18next'

import { DEFAULT_DATETIME_FORMAT, formatAsUTCDate } from './datetime'

type DisplayTextOrPlaceholderParams = {
  placeholder?: string
  t?: TFunction
  prefix?: string
}

export const displayTextOrPlaceholder = <T extends string | number>(
  value: T | null | undefined,
  overrideParams?: DisplayTextOrPlaceholderParams
): T | string => {
  const params = { placeholder: '- -', ...overrideParams }
  const { placeholder, t, prefix } = params

  if (!value) {
    return placeholder
  }

  if (typeof value === 'string' && value.trim() === '') {
    return placeholder
  }

  if (t) {
    return t(String(value))
  }

  if (prefix) return `${prefix} ${value}`

  return value
}

export const getUTCDateOrDisplayPlaceholder = (
  field: string | null | undefined,
  format = DEFAULT_DATETIME_FORMAT
) => {
  if (!field) {
    return displayTextOrPlaceholder(null) as string
  }
  return formatAsUTCDate(field, format)
}
